import Vue from 'vue'
import Router from 'vue-router'
import { store } from './store'
import Login from './pages/Login/Login'
import Certs from './pages/Certs/Certs'
import Document from './pages/Certs/Document'
import Dashboard from './pages/Dashboard/Dashboard'
import Agency from './pages/Dashboard/Agency/Agency'
import Business from './pages/Dashboard/Business'
import GeneralAgent from './pages/Dashboard/GA/GeneralAgent'
import GeneralAgentHome from './pages/Dashboard/GA/Home'
import GroupAdmin from './pages/Dashboard/Group/Group'
import GroupHome from './pages/Dashboard/Group/Home'
import GroupView from './pages/Dashboard/Group/View'
import GroupUpdate from './pages/Dashboard/Group/GroupAdminUpdate'

import Producer from './pages/Dashboard/Producer/Producer'
import Enrollment from './pages/Dashboard/Enrollment/Enrollment'
import ProducerHome from './pages/Dashboard/Producer/Home'
import Group from './pages/Dashboard/Producer/Group'
import PendingTerms from './pages/Dashboard/Producer/PendingTerms'
import ProducerUpdate from './pages/Dashboard/Producer/ProducerUpdate'
import Member from './pages/Dashboard/Member/Member'
import MemberHome from './pages/Dashboard/Member/Home'
import PendingActions from './pages/Dashboard/Producer/PendingActions'
import PendingDetails from './pages/Dashboard/Producer/PendingDetails'
import AddressChange from './pages/Dashboard/Member/AddressChange'
import Dependents from './pages/Dashboard/Member/Dependents'
import TempIDCard from './pages/Dashboard/Member/TempIDCard'
import PlanSelection from './pages/Dashboard/Enrollment/PlanSelection'
import MemberEnroll from './pages/Dashboard/Enrollment/MemberEnroll'
import Preferences from './pages/Dashboard/User/Preferences'
import Password from './pages/Dashboard/User/Password'
import AddProducer from './pages/Dashboard/GA/AddProducer'
import PendingAppointment from './pages/Dashboard/GA/PendingAppointment'
import AssignGroup from './pages/Dashboard/GA/AssignGroup'

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Login
        },
        {
            path: '/certs',
            name: 'certs',
            component: Certs
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            meta: {
                requiresAuth: true
            },
            component: Dashboard,
            children: [
                {
                    path: 'document/:type/:hash',
                    name: 'doc',
                    component: Document,
                    props: true
                },
                {
                    path: 'agency',
                    name: 'agency',
                    component: Agency,
                },
                {
                    path: 'business',
                    name: 'business',
                    component: Business,
                },
                {
                    path: 'general-agent',
                    component: GeneralAgent,
                    children: [
                        {
                            path: '',
                            name: 'generalagent',
                            component: GeneralAgentHome
                        },
                        {
                            path: 'add/producer',
                            name: 'add-producer',
                            component: AddProducer
                        },
                        {
                            path: 'pending-appointment',
                            name: 'pending-appointment',
                            component: PendingAppointment
                        },
                        {
                            path: 'assign/:bid',
                            name: 'assign-group',
                            props: true,
                            component: AssignGroup
                        }
                    ]
                },
                {
                    path: 'producer',
                    component: Producer,
                    children: [
                        {
                            path: '',
                            name: 'producer',
                            component: ProducerHome
                        },
                        {
                            path: 'group/:groupcode',
                            name: 'groupview',
                            component: Group,
                            props: true,
                        },
                        {
                            path: 'pending-terms',
                            name: 'pending-terms',
                            component: PendingTerms
                        },
                        {
                            path: 'pending-actions',
                            name: 'pending-actions',
                            component: PendingActions
                        },
                        {
                            path: 'pending-details/:id',
                            name: 'pending-details',
                            component: PendingDetails,
                            props: true
                        },
                        {
                            path: 'update',
                            name: 'update',
                            component: ProducerUpdate
                        },
                        {
                            path: 'preferences',
                            name: 'preferences',
                            component: Preferences
                        },
                        {
                            path: 'password',
                            name: 'password',
                            component: Password
                        }
                    ]
                },
                {
                    path: 'group-admin',
                    component: GroupAdmin,
                    children: [
                        {
                            path: '',
                            name: 'group-admin',
                            component: GroupHome
                        },
                        {
                            path: 'group/:groupcode',
                            name: 'group-admin-view',
                            component: GroupView,
                            props: true,
                        },
                        {
                            path: 'pending-terms',
                            name: 'group-pending-terms',
                            component: PendingTerms
                        },
                        {
                            path: 'pending-actions',
                            name: 'group-pending-actions',
                            component: PendingActions
                        },
                        {
                            path: 'update',
                            name: 'update',
                            component: GroupUpdate
                        },
                        {
                            path: 'preferences',
                            name: 'group-preferences',
                            component: Preferences
                        }
                    ]
                },
                {
                    path: 'enroll/:groupcode',
                    component: Enrollment,
                    props: true,
                    children: [
                        {
                            path: '',
                            name: 'enroll',
                            props: true,
                            component: MemberEnroll
                        },
                        {
                            path: ':enrollId',
                            name: 'plan',
                            props: true,
                            component: PlanSelection
                        }
                    ]
                },
                {
                    path: 'member/:cert',
                    component: Member,
                    props: true,
                    children: [
                        {
                            path: '/',
                            name: 'view-member',
                            component: MemberHome
                        },
                        {
                            path: 'address',
                            name: 'change-address',
                            component: AddressChange
                        },
                        {
                            path: 'dependents',
                            name: 'change-dependents',
                            component: Dependents
                        },
                        {
                            path: 'temp-id-card',
                            name: 'temp-id-card',
                            component: TempIDCard
                        }
                    ]
                }
            ]
        }
    ]
})

router.beforeEach((to, from, next) => {
    //If this is a protected state check the token and the user
    if (to.matched.some(record => record.meta.requiresAuth)) {
        //Check for expired token
        if (Date.now() >= localStorage.getItem('expires') * 1000) {
            store.dispatch('logout').then(() => {
                next('/')
            })
            return
        }
        if (store.getters.currentUser !== null) {
            next()
            return
        }
        next('/')
    } else {
        next()
    }
})

export default router
